import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import '../styles/EDCCTermsConditions.css';
import { useNavigate } from 'react-router-dom';

const EDCCOldMemberTermsConditions = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [viewerLoaded, setViewerLoaded] = useState(false);
    const [useFastViewer, setUseFastViewer] = useState(true);

    // const pdfUrl = 'https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/1759559428155-AIOTA%20Regulation%20for%20CERTIFICATION%20%28Guidelines%29%202024-2028%20%281%29.pdf';
    const pdfUrl = 'https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/1776842633466-AIOTA%20Regulation%20for%20CERTIFICATION%20%28Guidelines%29%202024-2028.pdf';

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        const preloadViewer = () => {
            if (!viewerLoaded) {
                const viewerIframe = document.createElement('iframe');
                viewerIframe.style.display = 'none';
                viewerIframe.src = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`;
                document.body.appendChild(viewerIframe);
                setTimeout(() => {
                    document.body.removeChild(viewerIframe);
                    setViewerLoaded(true);
                }, 1000);
            }
        };

        setTimeout(preloadViewer, 500);

        return () => window.removeEventListener('resize', checkMobile);
    }, [viewerLoaded, pdfUrl]);

    const handleNotNowClick = () => {
        navigate("/");
    };

    const getFastPdfViewerUrl = () => {
        return `${pdfUrl}#zoom=page-width`;
    };

    const getGoogleViewerUrl = () => {
        return `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(pdfUrl)}`;
    };

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    return (
        <>
            <section
                className="hero-fixed"
                style={{ backgroundImage: `url(${heroBg})` }}>
                <div className="hero-scroll-content">
                    <div className="hero-content-home poppins-regular">
                        <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
                    </div>
                </div>
            </section>

            <div className="scrollable-content-home">
                <div className="content-container">
                    <Container className="terms-container py-3 py-md-5">
                        <h3 className="text-center mb-3 mb-md-4" style={{
                            fontSize: isMobile ? '1.5rem' : '1.75rem'
                        }}>
                            Terms and conditions (Old EDCC member)
                        </h3>
                        <p style={{
                            fontSize: isMobile ? '0.9rem' : '1rem',
                            lineHeight: '1.6'
                        }}>
                            Before starting your registration as an old EDCC member with existing certificates, please read the guidelines provided below. Please ensure you go through them completely before proceeding further.
                        </p>

                        <div className="pdf-container mb-3 mb-md-4" style={{
                            width: '100%',
                            height: isMobile ? '60vh' : '75vh',
                            minHeight: isMobile ? '400px' : '500px',
                            maxHeight: '1000px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            backgroundColor: '#f8f9fa',
                            position: 'relative'
                        }}>
                            {isLoading && (
                                <div className="d-flex align-items-center justify-content-center h-100">
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading PDF Viewer...</p>
                                    </div>
                                </div>
                            )}

                            <iframe
                                src={useFastViewer ? getFastPdfViewerUrl() : getGoogleViewerUrl()}
                                width="100%"
                                height="100%"
                                title="Terms and Conditions PDF"
                                style={{
                                    border: 'none',
                                    display: isLoading ? 'none' : 'block'
                                }}
                                onLoad={handleIframeLoad}
                                loading="eager"
                                allow="fullscreen"
                                referrerPolicy="no-referrer"
                            />
                        </div>

                        <div className="text-center mb-3">
                            <small className="text-muted" style={{
                                fontSize: isMobile ? '0.8rem' : '0.875rem',
                                display: 'block',
                                padding: '0 10px'
                            }}>
                                Having trouble viewing? {' '}
                                <a
                                    href={pdfUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none fw-bold"
                                >
                                    Open PDF in a new tab
                                </a>
                                {' '} • {' '}
                                <a
                                    href={pdfUrl}
                                    download="AIOTA_Certification_Guidelines.pdf"
                                    className="text-decoration-none fw-bold"
                                >
                                    Download PDF
                                </a>
                            </small>
                        </div>

                        {/* Buttons - Only Not Right Now and I am an old member with existing certificates */}
                        <div className="text-center mt-3 mt-md-4" style={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: 'center',
                            gap: isMobile ? '10px' : '0',
                            padding: isMobile ? '0 10px' : '0'
                        }}>
                            <button
                                className="btn btn-secondary notrightnow-btn"
                                onClick={handleNotNowClick}
                                style={{
                                    marginRight: isMobile ? '0' : '0.5rem',
                                    width: isMobile ? '100%' : 'auto',
                                    fontSize: isMobile ? '0.9rem' : '1rem',
                                    padding: isMobile ? '10px 20px' : '0.375rem 0.75rem'
                                }}
                            >
                                Not Right Now
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={() => navigate('/edcc-old-member-form')}
                                style={{
                                    width: isMobile ? '100%' : 'auto',
                                    fontSize: isMobile ? '0.9rem' : '1rem',
                                    padding: isMobile ? '10px 20px' : '0.375rem 0.75rem'
                                }}
                            >
                                I am an old member with existing certificates
                            </button>
                        </div>
                    </Container>
                </div>
            </div>
        </>
    );
};

export default EDCCOldMemberTermsConditions;
